import React from 'react';

import { useIntl } from 'react-intl';

import { Col, Row } from 'antd';
import PropTypes from 'prop-types';

import LabelValue from '../../../../../../components/LabelValue';
import styles from './styles.module.less';

const ChartInfo = ({ eventName = '', formName = '', componentName = '' }) => {
  const intl = useIntl();
  return (
    <Row gutter={[8, 8]}>
      {eventName && (
        <Col span={24}>
          <LabelValue
            className={styles.labelValueWrapper}
            name={intl.formatMessage({ id: 'triggers.view.form.eventType' })}
            value={eventName}
          />
        </Col>
      )}
      {formName && (
        <Col span={24}>
          <LabelValue
            className={styles.labelValueWrapper}
            name={intl.formatMessage({ id: 'triggers.view.title' })}
            value={formName}
          />
        </Col>
      )}
      {componentName && (
        <Col span={24}>
          <LabelValue
            className={styles.labelValueWrapper}
            name={intl.formatMessage({ id: 'form.view.components' })}
            value={componentName}
          />
        </Col>
      )}
    </Row>
  );
};

ChartInfo.propTypes = {
  eventName: PropTypes.string,
  formName: PropTypes.string,
  componentName: PropTypes.string,
};

export default ChartInfo;
